<template lang="html">
  <el-dialog visible :title="title" :width="width" :before-close="onDestroy">
    <slot></slot>
    <div slot="footer">
      <el-button size="mini" @click="onDestroy">取 消</el-button>
      <el-button size="mini" type="primary" @click="onSure">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data: () => ({
    title: '',
    width: '600px',
    onSure: () => {},
    onDestroy: () => {}
  })
}
</script>